// Architecture style based on Atomic Design Pattern

// https://bradfrost.com/blog/post/atomic-web-design/
export enum WidgetType {
  // templates
  t_page = 't_page',
  t_project_indicator_page = 't_project_indicator_page',
  t_asset_page = 't_asset_page',

  // organisms
  o_card = 'o_card',
  o_project_indicator_card = 'o_project_indicator_card',
  o_details_graph_card = 'o_details_graph_card',
  o_indicator_card = 'o_indicator_card',
  o_recommendation_card = 'o_recommendation_card',
  o_dialog_base = 'o_dialog_base',
  o_report_card = 'o_report_card',
  o_article_card = 'o_article_card',
  o_link_card = 'o_link_card',
  o_dialog = 'o_dialog',
  o_dialog_header = 'o_dialog_header',
  o_dialog_content = 'o_dialog_content',
  o_dialog_body = 'o_dialog_body',
  o_dialog_close = 'o_dialog_close',
  o_dialog_footer = 'o_dialog_footer',

  o_simple_table = 'o_simple_table',
  o_composite_graph = 'o_composite_graph',
  o_recommendation_default_card = 'o_recommendation_default_card',
  o_recommendation_summary = 'o_recommendation_summary',
  o_map_layer = 'o_map_layer',

  o_reports_list = 'o_reports_list',

  o_form = 'o_form',
  o_form_picker = 'o_form_picker',
  o_form_picker_trigger = 'o_form_picker_trigger',
  o_form_picker_content = 'o_form_picker_content',
  o_form_radio_group = 'o_form_radio_group',
  o_form_radio_item = 'o_form_radio_item',
  o_form_section = 'o_form_section',
  o_form_button = 'o_form_button',
  o_form_submit_button = 'o_form_submit_button',
  o_form_clear_button = 'o_form_clear_button',
  o_form_checkbox = 'o_form_checkbox',
  o_form_calendar = 'o_form_calendar',
  o_form_text_input = 'o_form_text_input',
  o_accordion_wrapper = 'o_accordion_wrapper',
  o_accordion_section = 'o_accordion_section',
  o_c_form_label_values_section = 'o_c_form_label_values_section',
  o_c_form_plots_section = 'o_c_form_plots_section',
  o_c_form_radio_group_habitat_intactness_years = 'o_c_form_radio_group_habitat_intactness_years',

  o_stewarded_value = 'o_stewarded_value',
  o_total_account_value = 'o_total_account_value',
  o_total_size = 'o_total_size',
  o_total_assets = 'o_total_assets',
  o_ecological_integrity_index = 'o_ecological_integrity_index',

  o_fact_summary = 'o_fact_summary',

  o_c_plot_group_filters = 'o_c_plot_group_filters',
  o_c_plot_group_filters_management = 'o_c_plot_group_filters_management',
  o_c_plot_group_sort = 'o_c_plot_group_sort',
  o_c_plot_group_additional_plots_filter_pills = 'o_c_plot_group_additional_plots_filter_pills',

  o_c_land_distribution_chart = 'o_c_land_distribution_chart',
  o_c_nature_health_overview = 'o_c_nature_health_overview',

  o_c_risk_aggregated_overview = 'o_c_risk_aggregated_overview',
  o_c_risk_sector_chart = 'o_c_risk_sector_chart',
  o_c_risk_overview = 'o_c_risk_overview',
  o_c_risk_chart = 'o_c_risk_chart',
  o_c_risk_info = 'o_c_risk_info',

  o_c_resilience_drivers_card = 'o_c_resilience_drivers_card',
  o_c_resilience_driver = 'o_c_resilience_driver',

  o_c_indicator_card_dialog = 'o_c_indicator_card_dialog',

  o_c_ranked_by_risk_plot_list = 'o_c_ranked_by_risk_plot_list',
  o_c_ranked_by_resilience_plot_list = 'o_c_ranked_by_resilience_plot_list',

  o_c_knowledge_cards = 'o_c_knowledge_cards',

  o_c_habitat_intactness_threats_table = 'o_c_habitat_intactness_threats_table',

  o_total_stocks_issued = 'o_total_stocks_issued',
  o_total_stocks_held = 'o_total_stocks_held',
  o_total_stocks_sold = 'o_total_stocks_sold',
  o_total_stocks_issued_value = 'o_total_stocks_issued_value',
  o_total_stocks_held_value = 'o_total_stocks_held_value',
  o_total_stocks_sold_value = 'o_total_stocks_sold_value',

  // Financial
  o_c_earnings_chart = 'o_c_earnings_chart',

  // molecules
  m_tooltip = 'm_tooltip',
  m_tooltip_content = 'm_tooltip_content',
  m_tooltip_trigger = 'm_tooltip_trigger',

  m_currency = 'm_currency',
  m_trend = 'm_trend',

  m_icon_button = 'm_icon_button',

  m_search_bar = 'm_search_bar',

  // atoms
  a_text_header = 'a_text_header',
  a_text_body = 'a_text_body',
  a_text_footer = 'a_text_footer',
  a_text = 'a_text',
  a_i18n_string = 'a_i18n_string',

  a_pill = 'a_pill',
  a_icon = 'a_icon',
  a_progress_bar = 'a_progress_bar',

  a_ul_list = 'a_ul_list',
  a_ol_list = 'a_ol_list',
  a_spinner = 'a_spinner',
  a_button = 'a_button',
  a_stack = 'a_stack',
  a_progress = 'a_progress',
  a_calendar = 'a_calendar',
  a_image = 'a_image',
  a_mail_link = 'a_mail_link',
}

export enum DefaultWidgetNames {
  // templates
  default_template_dashboard = 'default_template_dashboard',
  default_template_portfolio = 'default_template_portfolio',
  default_template_units = 'default_template_units',
  default_template_copilot = 'default_template_copilot',
  default_template_indicator_library = 'default_template_indicator_library',
  default_template_investments = 'default_template_investments',
  default_template_contracts = 'default_template_contracts',
  default_template_profile = 'default_template_profile',
  default_template_reports = 'default_template_reports',
  default_template_knowledge = 'default_template_knowledge',
  default_template_details = 'default_template_details',
  default_template_stocks = 'default_template_stocks',

  default_template_project_forest = 'default_template_project_forest',
  default_template_project_forest_carbon = 'default_template_project_forest_carbon',
  default_template_project_carbon = 'default_template_project_carbon',
  default_template_project_water = 'default_template_project_water',
  default_template_project_pofh = 'default_template_project_pofh',
  default_template_asset_carbon = 'default_template_asset_carbon',
  default_template_asset_bgc = 'default_template_asset_bgc',
  default_template_asset_water = 'default_template_asset_water',
  default_template_asset_pofh = 'default_template_asset_pofh',
  default_template_asset_social = 'default_template_asset_social',

  default_template_plot_list = 'default_template_plot_list',
  default_template_natural_capital_account = 'default_template_natural_capital_account',
  default_template_land_monitoring = 'default_template_land_monitoring',
  default_template_plot_detail = 'default_template_plot_detail',

  default_template_natural_capital = 'default_template_natural_capital',

  default_ecosystem_health_chart = 'default_ecosystem_health_chart',
  default_land_distribution_chart = 'default_land_distribution_chart',
  default_climate_risk_aggregated_overview = 'default_climate_risk_aggregated_overview',
  default_climate_risk_aggregated_chart = 'default_climate_risk_aggregated_chart',
  default_earnings_chart = 'default_earnings_chart',

  // organisms
  default_recommendation_card = 'default_recommendation_card',
  default_stewarded_value_card = 'default_stewarded_value_card',
  default_total_size_card = 'default_total_size_card',
  default_total_assets_card = 'default_total_assets_card',
  default_total_account_value_card = 'default_total_account_value_card',
  default_asset_fact_card = 'default_asset_fact_card',
  default_plot_group_filters = 'default_plot_group_filters',
  default_plot_group_filters_management = 'default_plot_group_filters_management',
  default_plot_group_sort = 'default_plot_group_sort',
  default_resilience_drivers_card = 'default_resilience_drivers_card',
  default_two_cards_section = 'default_two_cards_section',
  default_nca_metrics_sidebar = 'default_nca_metrics_sidebar',
  default_indicator_card_dialog = 'default_indicator_card_dialog',
  default_ranked_by_risk_plot_list = 'default_ranked_by_risk_plot_list',
  default_ranked_by_resilience_plot_list = 'default_ranked_by_resilience_plot_list',
  default_ecological_integrity_card = 'default_ecological_integrity_card',

  default_fact_card_carbon_total = 'default_fact_card_carbon_total',
  default_fact_card_historic_carbon_5y_uplift = 'default_fact_card_historic_carbon_5y_uplift',
  default_fact_card_historic_carbon_1y_uplift = 'default_fact_card_historic_carbon_1y_uplift',
  default_fact_card_current_bgc = 'default_fact_card_current_bgc',
  default_fact_card_historic_bgc_5y_uplift = 'default_fact_card_historic_bgc_5y_uplift',
  default_fact_card_projection_bgc_1y_uplift = 'default_fact_card_projection_bgc_1y_uplift',
  default_fact_card_current_bgc_co2 = 'default_fact_card_current_bgc_co2',
  default_fact_card_current_whc = 'default_fact_card_current_whc',
  default_fact_card_historic_water_5y_uplift = 'default_fact_card_historic_water_5y_uplift',
  default_fact_card_projection_water_1y_uplift = 'default_fact_card_projection_water_1y_uplift',
  default_fact_card_current_pofh = 'default_fact_card_current_pofh',
  default_fact_card_historic_pofh_5y_uplift = 'default_fact_card_historic_pofh_5y_uplift',
  default_fact_card_projection_pofh_1y_uplift = 'default_fact_card_projection_pofh_1y_uplift',
  default_fact_card_current_ndvi = 'default_fact_card_current_ndvi',
  default_fact_card_current_social = 'default_fact_card_current_social',
  default_fact_card_historic_social_5y_uplift = 'default_fact_card_historic_social_5y_uplift',
  default_fact_card_projection_social_1y_uplift = 'default_fact_card_projection_social_1y_uplift',
  default_total_stocks_issued_card = 'default_total_stocks_issued_card',
  default_total_stocks_issued_value_card = 'default_total_stocks_issued_value_card',
  default_total_stocks_held_card = 'default_total_stocks_held_card',
  default_total_stocks_held_value_card = 'default_total_stocks_held_value_card',
  default_total_stocks_sold_card = 'default_total_stocks_sold_card',
  default_total_stocks_sold_value_card = 'default_total_stocks_sold_value_card',

  // molecules
  default_project_canopy_cover_indicator_card = 'default_project_canopy_cover_indicator_card',
  default_project_canopy_height_indicator_card = 'default_project_canopy_height_indicator_card',
  default_project_agc_indicator_card = 'default_project_agc_indicator_card',
  default_project_bgc_indicator_card = 'default_project_bgc_indicator_card',
  default_project_total_carbon_indicator_card = 'default_project_total_carbon_indicator_card',
  default_project_whc_indicator_card = 'default_project_whc_indicator_card',
  default_project_pofh_indicator_card = 'default_project_pofh_indicator_card',
  default_project_deforestation_indicator_card = 'default_project_deforestation_indicator_card',
  default_project_social = 'default_project_social',
  default_summary = 'default_summary',
  default_recommendation_summary = 'default_recommendation_summary',
}

export enum GraphTileType {
  historic_below_ground_carbon = 'historic_below_ground_carbon',
  historic_above_ground_carbon = 'historic_above_ground_carbon',
  projection_below_ground_carbon = 'projection_below_ground_carbon',
  historic_water_soil_moisture = 'historic_water_soil_moisture',
  historic_precipitation_soil_moisture = 'historic_precipitation_soil_moisture',
  projection_water_soil_moisture = 'projection_water_soil_moisture',
  protected_on_farm_habitat = 'protected_on_farm_habitat',
  deforestation = 'deforestation',
  historic_deforestation = 'historic_deforestation',
  ndvi = 'ndvi',
  canopy_cover = 'canopy_cover',
  canopy_height = 'canopy_height',
  land_use_distribution = 'land_use_distribution',
  social_life_expectancy = 'social_life_expectancy',
  custom = 'custom',
  historic_habitat_intactness = 'historic_habitat_intactness',
  historic_habitat_intactness_threats_breakdown = 'historic_habitat_intactness_threats_breakdown',
}

export enum NCExplainerType {
  historic_below_ground_carbon = 'historic_below_ground_carbon',
  projection_below_ground_carbon = 'projection_below_ground_carbon',
  historic_above_ground_carbon = 'historic_above_ground_carbon',
  historic_water_soil_moisture = 'historic_water_soil_moisture',
  projection_water_soil_moisture = 'projection_water_soil_moisture',
  protected_on_farm_habitat = 'protected_on_farm_habitat',
  canopy_cover = 'canopy_cover',
  canopy_height = 'canopy_height',
  social = 'social',
}

export enum BenchmarkExplainerType {
  historic_below_ground_carbon = 'historic_below_ground_carbon',
  historic_water_soil_moisture = 'historic_water_soil_moisture',
  protected_on_farm_habitat = 'protected_on_farm_habitat',
  canopy_cover = 'canopy_cover',
  canopy_height = 'canopy_height',
}

type RepeatConfig = {
  data: string;
  key: string;
  template: WidgetSlot;
};

export type WidgetSlot = {
  name: string;
  type: WidgetType;
  visible: boolean;
  widgets?: WidgetSlot[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  relatedData?: any;
  repeat?: RepeatConfig;
};

export type WidgetConfiguration = {
  configurations: WidgetSlotConfiguration[];
  hidden_facts: string[];
};

export type WidgetSlotConfiguration = {
  name: string;
  type: WidgetType;
  widgets: WidgetSlot[];
};

export type Widget = {
  id: string;
  name: string;
  type: WidgetType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  widget_format: any;
};

export enum WidgetContextType {
  plot = 'plot',
  project = 'project',
  organization_report = 'organization_report',
  organization_graph = 'organization_graph',
}

/**
 * GET /api/v1/dashboard/widget/library
 */
export const GET_DASHBOARD_WIDGET_LIBRARY_PATH = 'dashboard/widget/library';
export type GetDashboardWidgetLibraryRequestPathVariables = undefined;
export type GetDashboardWidgetLibraryRequestQueryParams = undefined;
export type GetDashboardWidgetLibrarySuccessDto = Widget[];
export type GetDashboardWidgetLibraryErrorDto = Error;

/**
 * GET /api/v1/dashboard/widget/configuration/{organization_id}
 */
export const GET_DASHBOARD_WIDGET_CONFIGURATION_PATH = 'dashboard/widget/configuration/{organization_id}';
export type GetDashboardWidgetConfigurationRequestPathVariables = { organization_id: string };
export type GetDashboardWidgetConfigurationRequestQueryParams = undefined;
export type GetDashboardWidgetConfigurationSuccessDto = WidgetConfiguration;
export type GetDashboardWidgetConfigurationErrorDto = Error;
